import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SwitchIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
export const ChoiceRandomShuffleButton = ({
  onClick,
  disabled
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Button size="xs" variant="contained" intent="neutral" rounded="full" disabled={disabled} className={cn('hidden mobile-lg:flex', disabled && 'opacity-[0.54]')} leftSlot={<SwitchIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} />} onMouseDown={e => e.preventDefault()} onClick={e => {
    e.stopPropagation();
    onClick();
  }} data-sentry-element="Button" data-sentry-component="ChoiceRandomShuffleButton" data-sentry-source-file="ChoiceRandomShuffleButton.tsx">
      {t('build:mixChoices')}
    </Button>;
};